var _rect, _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#7783A1",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 15H28V20H28.5C29.8807 20 31 18.8807 31 17.5C31 16.1193 29.8807 15 28.5 15Z",
    stroke: "#7783A1",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 13C24.5 16.3195 24.5 25 24.5 25",
    stroke: "#7783A1",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.5L13.788 29.1728C14.087 30.2887 15.234 30.9509 16.3499 30.6519V30.6519C17.4657 30.3529 18.128 29.2059 17.829 28.0901L17.2057 25.7639",
    stroke: "#7783A1",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.513 23.4155L16.25 22.4338",
    stroke: "#7783A1",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28 25.3005V9.69951C28 8.93703 27.1809 8.45506 26.5144 8.82536L19.2265 12.8742C19.078 12.9567 18.9108 13 18.7409 13H11C10.4477 13 10 13.4477 10 14V21C10 21.5523 10.4477 22 11 22H18.7409C18.9108 22 19.078 22.0433 19.2265 22.1258L26.5144 26.1746C27.1809 26.5449 28 26.063 28 25.3005Z",
    stroke: "#7783A1",
    strokeWidth: 1.5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRnd);
export default __webpack_public_path__ + "static/media/rnd.b2fd9e35bfce24dc02a214de06497834.svg";
export { ForwardRef as ReactComponent };